import { render, staticRenderFns } from "./v-check-field.vue?vue&type=template&id=98c39290&scoped=true&"
import script from "./v-check-field.vue?vue&type=script&lang=js&"
export * from "./v-check-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c39290",
  null
  
)

export default component.exports